import { Routes, Route, Outlet } from "react-router";

import { Navbar } from "./shared/components/Navbar";
import { Home } from "./routes/Home";
import { GameAssets } from "./routes/GameAssets";

export function Routing() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <Navbar />
            <Outlet />
          </>
        }
      >
        <Route index element={<Home />} />
        <Route path="/assets/:gameId" element={<GameAssets />} />
      </Route>
    </Routes>
  );
}
